import React, { useCallback } from 'react';
import { Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';

import { StudioControlStyles } from '../styles';
import { Button } from '../../index';
import { CameraIcon } from '../../icon/solid';
import { selectStudioMode } from '../../../store/modules/studio/selectors';
import { setStudioMode } from '../../../store/modules/studio/actions';
import { StudioMode } from '../../../configs/studio';
import StudioToolTip from './StudioToolTip';

const CameraModeAction = () => {
  const classes = StudioControlStyles();
  const dispatch = useDispatch();
  const studioMode = useSelector(selectStudioMode);
  const isActive = studioMode === StudioMode.CAMERA;

  const onClick = useCallback(() => {
    if (!isActive) {
      dispatch(setStudioMode(StudioMode.CAMERA));
    }
  }, [dispatch, isActive]);

  return (
    <Grid item className={classes.mainActionContainer}>
      <StudioToolTip title="Camera control and settings">
        <Button
          onClick={onClick}
          className={clsx(
            classes.button,
            classes.circleButton,
            isActive ? classes.activeButton : '',
          )}
          classes={{
            label: classes.circleButton,
          }}
        >
          <CameraIcon className={classes.icon} />
        </Button>
      </StudioToolTip>
      <span className={classes.mainActionTitle}>
        Camera
      </span>
    </Grid>
  );
};

export default CameraModeAction;
